document.addEventListener('minicart:open', function() {
  let data = document.getElementById('minicart-customizer-data');
  data = JSON.parse(data.textContent);
  const emptyButtonText = data.customizer.empty_button_text;
  const emptyButtonURL = data.customizer.empty_button_url;
  const continueButton = document.querySelector('.minicart__empty-button');
  const continueButtonHTML = `<a href="${emptyButtonURL}" class="minicart__empty-button secondary-button">${emptyButtonText}</a>`;
  const footerMinicartSection = document.querySelector('.minicart__section.minicart__section--footer');
  if(continueButton) {
    return;
  }

  if(footerMinicartSection) {
    footerMinicartSection.innerHTML = footerMinicartSection.innerHTML + continueButtonHTML;
  }

}) 

document.addEventListener('DOMContentLoaded', function() {
  var timer;
  var count = 0;
  function updateOrderSummaryBlock() {
    console.log("updateOrderSummaryBlock: ", count);
    clearTimeout(timer);
    const orderSummaryBlock = document.querySelector('#cart .order-summary');
    if(!orderSummaryBlock) {
      timer = setTimeout(updateOrderSummaryBlock, 200);
    } else {
      const continueShoppingURL = '/';
      console.log("continueShoppingURL", continueShoppingURL);
      const checkoutBtn = document.querySelector('#cart .order-summary__checkout');
      console.log("checkoutBtn", checkoutBtn);
      checkoutBtn.insertAdjacentHTML('afterend', `
        <a href="${continueShoppingURL}" class="order-summary__continue-shopping">Continue Shopping</a>
      `);
    }
    count++;
  }
  
  if(window.location.pathname.includes('/cart')) {
    console.log("on cart page");
    // do on cart only stuff
    const orderSummaryBlock = document.querySelector('#cart .order-summary');
    if(!orderSummaryBlock) {
      timer = setTimeout(updateOrderSummaryBlock, 200);
    }
  }
})